import React from 'react';
import cn from 'classnames';

import styles from './links.less';

const FullWidthWrapper = (props) => {
  const { className, fullWidth, fullHeight, children, ...otherProps } = props;

  const expand = fullWidth || fullHeight;
  if (expand) {
    return (
      <div className={styles.fullWidth}>
        <div
          className={className}
          {...otherProps}
        >
          {children}
        </div>
      </div>
    )
  } 
    return (
      <div
          className={className}
          {...otherProps}
        >
          {children}
        </div>
    );
  
};

export default FullWidthWrapper